import { render, staticRenderFns } from "./ViewMyAcademy.vue?vue&type=template&id=25803bde&scoped=true"
import script from "./ViewMyAcademy.vue?vue&type=script&lang=js"
export * from "./ViewMyAcademy.vue?vue&type=script&lang=js"
import style0 from "./ViewMyAcademy.vue?vue&type=style&index=0&id=25803bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25803bde",
  null
  
)

export default component.exports